<!-- New Kanga Landing Page (feature flagged) -->
<ng-container *ngIf="showNewLanding; else legacyLanding">
  <div class="landing-grid">
    <h1 class="welcome" *ngIf="user">Welcome, {{ user.first_name }}! 👋</h1>

    <div class="main-content">
      <div class="workspace-card onboarding">
        <pl-onboarding-toolkit-card></pl-onboarding-toolkit-card>
      </div>

      <div class="bottom-row">
        <div class="workspace-card quick-links">
          <pl-quick-links-card></pl-quick-links-card>
        </div>

        <div class="workspace-card assistance">
          <pl-need-assistance-card></pl-need-assistance-card>
        </div>
      </div>
    </div>

    <div class="sidebar">
      <div class="workspace-card room">
        <div class="card-header-row">
          <h2>Your Room</h2>
          <a
            [href]="roomUrl"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Open room in new tab"
          >
            <mat-icon class="open-icon" aria-hidden="true"
              >open_in_new</mat-icon
            >
          </a>
        </div>
        <p class="room-url">{{ roomUrl }}</p>
        <button type="button" class="copy-link" (click)="copyRoomUrl()">
          <mat-icon>content_copy</mat-icon> Copy URL
        </button>
      </div>

      <div class="workspace-card schedule">
        <pl-schedule-card></pl-schedule-card>
      </div>
    </div>
  </div>
</ng-container>

<!-- Legacy Kanga Landing Page -->
<ng-template #legacyLanding>
  <div class="container">
    <h1 *ngIf="user" class="mt-4">Welcome, {{ user.first_name }}!</h1>
    <div class="row">
      <div class="col-lg-8">
        <div class="workspace-card">
          <h2>Clinical Support</h2>
          <ng-container *ngIf="isPaid">
            <h4>Ask a Clinician</h4>
            <div style="display: flex; flex-direction: row">
              <mat-icon class="icon-box icon-box-teal">help</mat-icon>
              <div style="flex: 3; margin-right: 1rem">
                Start a conversation with another clinician about how to use
                Kanga in your practice.
              </div>
              <div style="flex: 2">
                <a href="mailto:askaclinician@presence.com"
                  >askaclinician&#64;presence.com</a
                >
              </div>
            </div>
            <hr />
          </ng-container>
          <h4>Facebook Group</h4>
          <div style="display: flex; flex-direction: row">
            <mat-icon class="icon-box icon-box-blue">facebook</mat-icon>
            <div style="flex: 3; margin-right: 1rem">
              Join our active Facebook community to ask questions, grab lesson
              ideas, and learn from other clinicians.
            </div>
            <div style="flex: 2">
              <a
                href="https://www.facebook.com/groups/688197601802713"
                target="_blank"
                >Join our Facebook group</a
              >
            </div>
          </div>
        </div>
        <div class="workspace-card">
          <h2>Tech Support</h2>

          <h4>Tech Support Chat</h4>
          <p>Having tech issues? Chat with a real person right now.</p>
          <p>
            <a class="pl-link" target="_blank" (click)="openSupportChat()">
              Tech Support Chat
            </a>
          </p>
          <hr />
          <h4>Tech Check</h4>
          <a [href]="setupUrl" target="_blank">Run a Tech Check</a>
          to make sure your device works smoothly with our platform.
          <hr />
          <h4>Contact our Tech Team</h4>
          <p>
            <a href="mailto:asksupport@presence.com">
              asksupport&#64;presence.com
            </a>
          </p>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="workspace-card">
          <h2>Your Therapy Room</h2>
          <h4>Room URL</h4>
          <p style="overflow-wrap: anywhere">{{ roomUrl }}</p>
          <a
            (click)="copyRoomUrl()"
            href="javascript:void(0)"
            class="font-weight-bold"
            ><mat-icon class="align-middle">content_copy</mat-icon> Copy URL</a
          >
          @if (license$ | async; as license) {
          <h4 class="mt-4">Current License</h4>
          <span class="d-flex align-items-center">
            <mat-icon class="license-icon">workspace_premium</mat-icon>
            <span class="ml-1">{{ license }}</span>
          </span>
          @if(canUpgrade$ | async) {
          <div class="d-block w-100 mt-4">
            <p class="text-center mb-1">Upgrade for premium features</p>
            <a
              [routerLink]="['/purchase']"
              mat-raised-button
              class="font-weight-bold w-100 upgrade-button"
            >
              Upgrade now
            </a>
          </div>
          } }
        </div>

        <div class="workspace-card">
          <h2>Onboarding Toolkit</h2>
          <h4>Training Opportunities</h4>
          <ul>
            <li *ngIf="isPaid">
              @if (isSiriusEnabled) {
              <a
                (click)="openLmsPortal()"
                [class.disabled]="isLmsLoading()"
                class="lms-link"
              >
                Telehealth Institute
              </a>
              } @else {
              <a [href]="lms_url" target="_blank">Telehealth Institute</a>
              }
            </li>
            <li *ngIf="!isPaid">
              <a
                href="https://support.presence.com/hc/en-us/articles/27203471622803-Getting-Started-with-Kanga"
                target="_blank"
                >Starter Guide</a
              >
            </li>
            <li>
              <a href="https://support.presence.com" target="_blank"
                >Help Center</a
              >
            </li>
            <li *ngIf="isPaid">
              Office Hours
              <ul>
                <li>
                  <a
                    href="https://calendly.com/kangaofficehours/kanga-slp-office-hours"
                    target="_blank"
                    >SLP</a
                  >
                </li>
                <li>
                  <a
                    href="https://calendly.com/kangaofficehours/kanga-ot-pt-office-hours"
                    target="_blank"
                    >OT</a
                  >
                </li>
                <li>
                  <a
                    href="https://calendly.com/kangaofficehours/kanga-mh-office-hours"
                    target="_blank"
                    >Behavioral / Mental Health</a
                  >
                </li>
                <li>
                  <a
                    href="https://calendly.com/kangaofficehours/kanga-school-psych-office-hours"
                    target="_blank"
                    >Psycho-Educational & Academic Achievement</a
                  >
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</ng-template>
